import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Monitor = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M8.001 14.7a.333.333 0 0 1-.333-.334v-2a.333.333 0 1 1 .667 0v2A.333.333 0 0 1 8 14.7Z" />
      <path d="M12 15.367a.334.334 0 0 1-.123-.024A11.603 11.603 0 0 0 8 14.7c-1.319-.007-2.63.21-3.876.643a.333.333 0 0 1-.247-.619A12.047 12.047 0 0 1 8 14.034c1.405-.012 2.8.221 4.124.69a.333.333 0 0 1-.124.643ZM.667 1.367h14.667a.333.333 0 0 1 .333.334v10.666a.333.333 0 0 1-.333.333H.667a.333.333 0 0 1-.333-.333V1.7a.333.333 0 0 1 .333-.334ZM15 2.034H1v10h14v-10Z" />
      <path d="M15.334 10.7H.667a.333.333 0 1 1 0-.667h14.667a.333.333 0 1 1 0 .667Z" />
    </svg>
  );
};

Monitor.category = 'product-category';

Monitor.displayName = 'Monitor';
